<template>
 <div>
   <div class="coworker-grid">
     <template v-for="item in this.originalItems">
         <div class="">
           <div class="coworker mb-3">
             <div class="image" role="button" v-on:click="showPopup(item)">
               <img
                 :src="item.image"
                 :srcset="item.imagesrcset"
                 sizes="(min-width: 1400px) 324px, (min-width: 992px) calc( (100vw - 105px) / 4 ), (min-width: 576px) 210px, calc((100vw - 75px) / 2 )"
               >
             </div>
             <div class="d-flex flex-column">
               <span role="button" v-on:click="showPopup(item)">
                 <h4 class="fs-18-light mt-1">{{ item.name }}</h4>
                 <p class="text-grey" v-html="item.titleCard"></p>
               </span>
               <p class="mb-0_5 d-flex flex-wrap" v-if="item.phoneStr"><span class="w-100-mobile mr-0_5">Tel: </span><a :href="'tel: ' + item.phone" class="text-turquoise overflow-ellipsis">{{ item.phoneStr }}</a></p>

               <p class="mb-0_5 d-flex flex-wrap" v-if="item.cellphoneStr"><span class="w-100-mobile mr-0_5">Mobil: </span><a :href="'tel: ' + item.cellphone" class="text-turquoise overflow-ellipsis">{{ item.cellphoneStr }}</a></p>

               <p class="d-flex flex-wrap" v-if="item.mail"><span class="w-100-mobile mr-0_5">E-post: </span><a :href="'mailto:' + item.mail" class="text-turquoise overflow-ellipsis">{{ item.mail }}</a></p>
               <button class="text-turquoise no__styling text-left realtor-popup" v-on:click="showPopup(item)">Läs mer</button>
             </div>
           </div>
         </div>
     </template>
   </div>

   <div class="popup-wrapper-realtor" :class="{ visible: popupVisible }">
     <div class="popup">
       <div class="popup-close" v-on:click="closePopup"></div>
       <div class="d-flex flex-wrap align-items-start">
         <img
           :src="visibleCoworker.image"
           :srcset="visibleCoworker.imagesrcset"
           sizes="(min-width: 1400px) 290px, (min-width: 992px) calc( (100vw - 180px) / 4 ), (min-width: 768px) 180px, (min-width: 576px) 210px, calc(100vw - 60px)"
         >
         <div class="ml-sm-5 mt-2 mt-md-0 realtor-info">
           <h2 class="text-turquoise text-border mb-1">{{ visibleCoworker.name }}</h2>
           <p v-html="visibleCoworker.titleCard"></p>
           <p class="mb-0_5" v-if="visibleCoworker.phone">Tel: <a :href="'tel: ' + visibleCoworker.phone" class="text-turquoise">{{ visibleCoworker.phoneStr }}</a></p>
           <p class="mb-0_5" v-if="visibleCoworker.cellphone">Mobil: <a :href="'tel: ' + visibleCoworker.cellphone" class="text-turquoise">{{ visibleCoworker.cellphoneStr }}</a></p>
           <p class="mb-0_5" v-if="visibleCoworker.mail">E-post: <a :href="'mailto:' + visibleCoworker.mail" class="text-turquoise">{{ visibleCoworker.mail }}</a></p>
           <p class="mt-3">{{ visibleCoworker.presentation }}</p>

           <div v-if="visibleCoworker.recoRating" class="d-flex mt-3">
             <img :src="recoIcon" alt="Reco icon" class="mr-2 mr-md-3"/>
             <div>
               <p>Så tycker våra kunder</p>
               <span class="rating">{{ visibleCoworker.recoRating }} / 5.0 i betyg – <a target="_blank" class="text-turquoise" :href="'https://reco.se/' + visibleCoworker.recoLink">{{ visibleCoworker.recoTotal }} rekommendationer</a></span>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>

 </div>

</template>

<script>
export default {
  data: function() {
    return {
      filename: 'realtors',
      originalItems: [],
      popupVisible: false,
      visibleCoworker: [],
      recoIcon: prekApiSettings.template_path + '/resources/images/reco-symbol.svg',
    };
  },
  methods: {
    showPopup: function(item) {
      const mainWrapper = document.querySelector('#main');
      if (mainWrapper.dataset.aos) {
        delete mainWrapper.dataset.aos;
      }
      this.visibleCoworker = item;
      this.popupVisible = true;
    },
    closePopup: function() {
      this.popupVisible = false;
    },
    shuffle: function(array) {
      let currentIndex = array.length,  randomIndex;

      // While there remain elements to shuffle...
      while (currentIndex != 0) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }

      return array;
    },
    coworkerUrl: function() {
      let coworker = window.location.hash.substr(1);
      let search = decodeURIComponent(window.location.search);
      if (!coworker && search.includes('#')) {
        /*
        Links from Instagram are like this:
        https://www.gofab.se/kontakta-oss/?fbclid=PAAaY04Bc9Fde9xY2PqwxQF-flpXElIUT4VZsLPxrFrJW1ce2a1iqLX98oGf0%23peteroskarsson
         */
        let parts = search.split('#');
        if (parts && parts[1]) {
          coworker = parts[1];
        }
      }

      if (coworker) {
        const coworkerToShow = this.originalItems.find(item => {
          return item.name.toLowerCase().replace(/ /g,'') === coworker;
        });

        if (coworkerToShow) {
          this.showPopup(coworkerToShow);
        }
      }
    },
  },
  mounted: function() {

    fetch(prekApiSettings.uploads_path + '/' + this.filename + prekApiSettings._fasad_lastsync + '.json', {}).then((response) => {
      return response.json();
    }).then((data) => {
      this.originalItems = _.filter(data, function(item) {
        return item;
      });
      this.shuffle(this.originalItems);
      this.coworkerUrl();
    });
  },
}
</script>

<style scoped>

.realtor-info {
  flex: 1;
}

</style>
